<template>
  <header class="header">
    <h1 class="">Chat-Dokumentation</h1>
  </header>
</template>
